import React from "react";

// 読み込み中の表示。表示制御は呼び出し側（{loading && <Loader />} 等）。
export default function Loader() {
  return <div className="mp-loader">読み込み中…</div>;
}
